import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button, Form, DatePicker, TimePicker, Radio, Upload, Icon, Input, InputNumber, Row, Col, message } from 'antd'
const FormItem = Form.Item
const RangePicker = DatePicker.RangePicker
const RadioButton = Radio.Button
const RadioGroup = Radio.Group
import FileUpload from './fileUpload'

import { startProcessinStance } from '../../../action/process/startProcessinStance'
import { changeModalVisible } from '../../../action/process/mutations'
import { CLOSE_TIME, API_CODE_SUCCESS } from '../../../config'

import OvertimeStarTimeItemList from './overtimeStarTimeItemList'

class SForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      submitBtnDisabled: false,
      hasError: false,
    }
  }
  componentWillMount() {

  }

  componentWillReceiveProps(props) {
    console.log('overtime----', props);
    if (props.visible != this.props.visible && props.visible) {
      this.props.form.resetFields();
    }
  }

  submitStartProcessinStance = (params) => {
    const { startProcessinStance, changeModalVisible, reSubmitHandle } = this.props
    return new Promise((resolve, reject) => {
      if (reSubmitHandle) {
        reSubmitHandle(params).then(({ retCode, retData, retMsg }) => {
          if (retCode === API_CODE_SUCCESS) {
            message.success(retMsg, CLOSE_TIME, () => {
              onCancel(false)
              resolve()
            })
          }
          else {
            reject(new Error(retMsg))
          }
        })
      }
      else {
        startProcessinStance(params).then(({ retCode, retData, retMsg }) => {
          if (retCode === API_CODE_SUCCESS) {
            message.success(retMsg, CLOSE_TIME, () => {
              changeModalVisible(false)
              resolve()
            })
          }
          else {
            reject(new Error(retMsg))
          }
        })
      }
    })
  }
  workTimesValidatorHandle = (rule, value, callback) => {
    if (typeof value === 'number') {
      if (value >= 0 && value % 1 === 0) {
        callback()
      } else {
        callback('加班时间必须大于零的整数！')
      }
    } else {
      callback('请输入加班时间！')
    }
  }
  handleSubmit = (e) => {
    e.preventDefault()
    const { processDefinitionId } = this.props
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const {
          time,
          description
        } = values
        if (!time) {
          return this.setState({ hasError: true });
        }
        for (var t of time) {
          if (!t.date || !t.start || !t.end || !t.workTimes) {
            return this.setState({ hasError: true });
          }
        }
        this.setState({ hasError: false });
        this.setState({ submitBtnDisabled: true });
        const params = {
          processDefinitionId,
          'businessVariables[time]': JSON.stringify(time),
          'businessVariables[description]': description
        }
        console.log('values::::', params);
        this.submitStartProcessinStance(params)
          .then(() => this.setState({ submitBtnDisabled: false }))
          .catch(() => this.setState({ submitBtnDisabled: false }))
      } else {
        this.setState({ submitBtnDisabled: false })
      }
    })
  }

  render() {

    const { getFieldDecorator, getFieldValue, setFieldsValue } = this.props.form;
    const { businessDetail } = this.props;
    const formItemLayout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 }
    }
    const config = {
      type: { rules: [{ type: 'number', required: true, message: '请选择请假种类!' }] },
      description: { rules: [{ type: 'string', min: 0, max: 200, required: true, message: '请输入原因!' }], initialValue: businessDetail ? businessDetail.description : '' },
      time: { rules: [{ type: 'array', required: true, message: '请选择时长' }], initialValue: [] },
      attachmentId: {
        rules: [{ type: 'array', required: this.state.attachmentIdRequired, message: '请上传附件!' }]
      }
    }
    return (
      <Form onSubmit={this.handleSubmit}>
        <FormItem {...formItemLayout} label="时长">
          {getFieldDecorator('time')(
            <OvertimeStarTimeItemList visible={this.props.visible} hasError={this.state.hasError} detail={businessDetail ? businessDetail.detail : []} />
          )}
        </FormItem>
        <FormItem {...formItemLayout} label="原因">
          {getFieldDecorator('description', config.description)(
            <Input type="textarea" placeholder="请输入加班原因，不超过200字" />
          )}
        </FormItem>
        <FormItem wrapperCol={{ span: 20, offset: 4 }}>
          <Button type="primary" htmlType="submit" disabled={this.state.submitBtnDisabled} size="large">提交</Button>
        </FormItem>
      </Form>
    );
  }
}

function mapStateToProps(state) {
  const {
		page: {
      processDefinitionId,
    visible
		},
    user
	} = state
  return {
    processDefinitionId,
    visible,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    changeModalVisible: (bool) => dispatch(changeModalVisible(bool)),
    startProcessinStance: (params) => dispatch(startProcessinStance(params))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(SForm))



// WEBPACK FOOTER //
// ./src/components/process/formWrapper/overtimeStartForm.js